import moment from 'moment';

export const formatDate = date => moment(date).format('D. MM. YYYY');
export const formatTime = (start, end) => `${moment(start).format('H:mm')}-${moment(end).format('H:mm')}`;

export const isMoreDayEvent = (startDate, endDate) => moment(startDate).isBefore(moment(endDate)) && moment(startDate).days() !== moment(endDate).days(); 
